import React, { useEffect, useState } from 'react';
import { IoClose } from "react-icons/io5";
import amazon from "../../Assets/img/algopix/shopping.png";
import ebay from "../../Assets/img/algopix/ebay.png";
import walmart from "../../Assets/img/algopix/walmart.png";
 
// Loader Component
const Loader = () => (
  <div className="flex items-center justify-center h-full">
    <div className="loader">Loading...</div>
  </div>
);
 
const platforms = [
  { name: "Amazon", imgSrc: amazon, dataKey: "amazonData" },
  { name: "eBay", imgSrc: ebay, dataKey: "ebayData" },
  { name: "Walmart", imgSrc: walmart, dataKey: "walmartData" }
];
 
const AlgopixUI = ({ handleClose, algopixdata, amazonData, ebayData, walmartData }) => {
  const [demand, setDemand] = useState(algopixdata?.demand?.US ?? 'N/A');
  const [demandLabel, setDemandLabel] = useState(() => {
    if (demand === -1) return 'Very Low';
    if (demand >= 1 && demand <= 4) return 'Low';
    if (demand === 5) return 'Medium';
    if (demand >= 6 && demand <= 10) return 'High';
    return 'N/A';
  });
 
  const dataMap = {
    amazonData,
    ebayData,
    walmartData
  };
 
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-white bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-4/5 h-4/5 overflow-auto">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-2xl font-bold text-red-600">Insights</h2>
          <button onClick={handleClose} className="text-red-500 text-2xl"><IoClose /></button>
        </div>
        {algopixdata === null ?
          <Loader /> :
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {platforms.map(platform => {
              const platformData = dataMap[platform.dataKey];
              return (
                <div key={platform.name} className="bg-gray-100 p-4 rounded shadow-md">
                  <div className="flex items-center mb-2">
                    <h3 className="text-xl font-bold">{platform.name}</h3>
                    <img className="h-8 ml-2" src={platform.imgSrc} alt={`${platform.name} logo`} />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Demand per Platform</label>
                    <input type="text" value={demandLabel} readOnly className="input border block w-full rounded-md shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Current Marketplace Price</label>
                    <input type="text" value={`$${platformData?.offers?.NEW?.marketPrice?.amount ?? '0'}`} readOnly className="input border block w-full rounded-md border-gray-300 shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Units Sold per Month</label>
                    <input type="text" value={`$${platformData?.marketSpecificData?.estimatedSalesRevenues?.amount ?? '0'}`} readOnly className="input border block w-full rounded-md border-gray-300 shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Sales per Month in Number of Transactions</label>
                    <input type="text" value={platformData?.marketSpecificData?.estimatedUnitSold ?? 'N/A'} readOnly className="input border block w-full rounded-md border-gray-300 shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Rank</label>
                    <input type="text" value={platformData?.marketSpecificData?.[`${platform.name.toLowerCase()}Categories`]?.[0]?.bestSellerRanking ?? 'N/A'} readOnly className="input border block w-full rounded-md border-gray-300 shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Number of Sellers</label>
                    <input type="text" value={platformData?.marketSpecificData?.competition?.numberOfOffers ?? 'N/A'} readOnly className="input border block w-full rounded-md border-gray-300 shadow-sm" />
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Product Listing Links</label>
                    <div className="block p-2.5 w-full text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {platformData?.offers?.NEW?.listingUrl
                        ? <a className="text-blue-500 hover:text-blue-700 underline" target="_blank" href={platformData?.offers?.NEW?.listingUrl} rel="noopener noreferrer">{platformData?.offers?.NEW?.listingUrl}</a>
                        : 'N/A'}
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-bold text-gray-700">Insights</label>
                    <div className="block p-2.5 w-full text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {platformData?.offers?.NEW?.insights?.join(', ') || 'N/A'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        }
      </div>
    </div>
  );
};
 
export default AlgopixUI;